import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gap } from "../../atoms";
import { Grid, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Map from "./map";
import Table from "./Table";
import {
  getOverviewKabkot,
  getOverviewProvinsi,
  getOverviewKecamatan,
} from "../../../config/Redux/Overview/actions";

const DetailAnggota = () => {
  const dispatch = useDispatch();
  let params = useParams();
  const [cari, setSearch] = useState("");
  const [toggle, setToggle] = useState("asc");
  const [orderBy, setOrderBy] = useState("nama_kab_kot");
  const [selectFilterPemenuhanTarget, setFilterPemenuhanTarget] =
    useState("all");
  const [selectFilterProvinsi, setFilterProvisni] = useState("all");
  const [optionOrderBy, setOptionOrder] = useState([
    { id: "nama_kab_kot", label: "Nama Kab/Kota" },
    { id: "nama_provinsi", label: "Nama Provinsi" },
    { id: "jumlah_anggota", label: "Jumlah Anggota" },
    { id: "target_pb", label: "Jumlah Target PB" },
    { id: "target_kpu", label: "Jumlah Target KPU" },
    { id: "jumlah_penduduk", label: "Jumlah Penduduk" },
  ]);
  const listProvinsi = useSelector((state) => state.global.dataProvince);
  const provinces = [
    { kode_prov_bps: "all", nama_prov_kemdagri: "Semua Provinsi" },
  ];
  for (let i = 0; i < listProvinsi?.data?.length; i++) {
    provinces.push(listProvinsi.data[i]);
  }

  const [dataKabkot, setDataKabkot] = useState([]);
  const dataOverview = useSelector((state) => state.overview);

  const updateData = (sortType, sortBy, filterTarget, filterProvinsi) => {
    if (params?.tingkatExcoId === "3") {
      let arr = dataOverview?.dataOverviewKabkot?.data?.data || [];
      let newArray = [];
      if (sortType === "asc") {
        newArray = arr.sort((a, b) => (a[sortBy] > b[sortBy] ? 1 : -1));
      } else {
        newArray = arr.sort((a, b) => (a[sortBy] < b[sortBy] ? 1 : -1));
      }
      if (filterTarget !== "all") {
        if (filterTarget === "0") {
          newArray = newArray.filter(function (el) {
            // return el.jumlah_pengurus_kabkot > 0 && el?.info_dokumen?.dokumen_sk_pengurus === 1 && el.jumlah_anggota >= el.target_pb
            return el?.is_verified === 1 && el.jumlah_anggota >= el.target_pb;
          });
        } else if (filterTarget === "1") {
          newArray = newArray.filter(function (el) {
            // return el.jumlah_pengurus_kabkot > 0 && el?.info_dokumen?.dokumen_sk_pengurus === 1
            return el?.is_verified === 1;
          });
        } else if (filterTarget === "2") {
          newArray = newArray.filter(function (el) {
            return el.jumlah_anggota >= el.target_pb;
          });
        } else if (filterTarget === "3") {
          newArray = newArray.filter(function (el) {
            return el.jumlah_anggota >= el.target_kpu;
          });
        } else {
          newArray = newArray.filter(function (el) {
            return (
              (el.jumlah_pengurus === 0 ||
                el?.info_dokumen?.dokumen_sk_pengurus !== 1) &&
              el.jumlah_anggota < el.target_pb
            );
          });
        }
      }
      if (filterProvinsi !== "all") {
        newArray = newArray.filter(function (el) {
          return el.id_provinsi === parseInt(filterProvinsi);
        });
      }
      setDataKabkot(newArray);
    }
  };
  useEffect(() => {
    if (!dataOverview?.dataOverviewKabkot?.data?.data?.length) {
      dispatch(getOverviewProvinsi(true));
      dispatch(getOverviewKabkot(true));
    }
    updateData(
      toggle,
      orderBy,
      selectFilterPemenuhanTarget,
      selectFilterProvinsi,
    );
  }, [dataOverview?.dataOverviewKabkot?.data?.data?.length]);

  const handleSort = (event) => {
    setOrderBy(event.target.value);
    updateData(
      toggle,
      event.target.value,
      selectFilterPemenuhanTarget,
      selectFilterProvinsi,
    );
  };
  const handleSortType = (value) => {
    setToggle(value);
    updateData(
      value,
      orderBy,
      selectFilterPemenuhanTarget,
      selectFilterProvinsi,
    );
  };
  const handlePemenuhanTarget = (event) => {
    setFilterPemenuhanTarget(event.target.value);
    updateData(toggle, orderBy, event.target.value, selectFilterProvinsi);
  };
  const handleProvinsi = (event) => {
    setFilterProvisni(event.target.value);
    updateData(
      toggle,
      orderBy,
      selectFilterPemenuhanTarget,
      event.target.value,
    );
  };

  const breadcrumbs = [
    <Link
      to={"/overview"}
      style={{
        textDecoration: "none",
        fontWeight: "bold",
        color: "black",
        fontSize: "14px",
      }}
    >
      Overview
    </Link>,
    <Typography
      key="2"
      color="text.primary"
      style={{ color: "#BDBDBD", fontSize: "14px", marginTop: "2px" }}
    >
      Anggota
    </Typography>,
  ];

  const filterData = (newArray, filterTarget) => {
    // let parameter1 = "";
    // if(params?.tingkatExcoId === "2"){
    // 	parameter1 = "jumlah_pengurus";
    // } else if(params?.tingkatExcoId === "3"){
    // 	parameter1 = "jumlah_pengurus_kabkot";
    // } else if(params?.tingkatExcoId === "4"){
    // 	parameter1 = "jumlah_pengurus_kecamatan";
    // }
    if (filterTarget !== "all") {
      if (filterTarget === "0") {
        newArray = newArray.filter(function (el) {
          // return el.jumlah_pengurus_kabkot > 0 && el?.info_dokumen?.dokumen_sk_pengurus === 1 && el.jumlah_anggota >= el.target_pb
          return el?.is_verified === 1 && el.jumlah_anggota >= el.target_pb;
        });
      } else if (filterTarget === "1") {
        newArray = newArray.filter(function (el) {
          // return el.jumlah_pengurus_kabkot > 0 && el?.info_dokumen?.dokumen_sk_pengurus === 1
          return el?.is_verified === 1;
        });
      } else if (filterTarget === "2") {
        newArray = newArray.filter(function (el) {
          return el.jumlah_anggota >= el.target_pb;
        });
      } else if (filterTarget === "3") {
        newArray = newArray.filter(function (el) {
          return el.jumlah_anggota >= el.target_kpu;
        });
      } else {
        newArray = newArray.filter(function (el) {
          return (
            (el.jumlah_pengurus === 0 ||
              el?.info_dokumen?.dokumen_sk_pengurus !== 1) &&
            el.jumlah_anggota < el.target_pb
          );
        });
      }
    }
    return newArray?.length || 0;
  };

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <div className="overview-detail-header">
        <Gap height={40} />
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          {breadcrumbs}
        </Breadcrumbs>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={8} md={6}>
            <p style={{ fontSize: 24, fontWeight: "bold", margin: "8px 0px" }}>
              Anggota Kab/Kota
            </p>
          </Grid>
          <Grid item xs={12} sm={4} md={6}>
            {params?.tingkatExcoId !== "4" ? (
              <div className="overview-filter-group">
                <span>Saring Provinsi</span>
                <br />
                <select
                  className="overview-filter-select"
                  onChange={handleProvinsi}
                >
                  {provinces.map((list, key) => {
                    return (
                      <option value={list.kode_prov_bps} key={key}>
                        {list.nama_prov_kemdagri}
                      </option>
                    );
                  })}
                </select>
              </div>
            ) : null}
            {params?.tingkatExcoId !== "4" ? (
              <div className="overview-filter-group">
                <span>Saring Pemenuhan Syarat</span>
                <br />
                <select
                  className="overview-filter-select"
                  onChange={handlePemenuhanTarget}
                >
                  <option value="all">Tampil Semua</option>
                  <option value="0">Memenuhi Syarat</option>
                  <option value="1">Keberadaan Exco</option>
                  <option value="2">Memenuhi Target PB</option>
                  <option value="3">Memenuhi Standar KPU</option>
                  <option value="4">Tidak Memenuhi Syarat</option>
                </select>
              </div>
            ) : null}
          </Grid>
        </Grid>
      </div>
      <Gap height={120} />
      <Gap height={50} />
      <div
        style={{
          fontSize: "10px",
          color: "grey",
          border: "1px grey solid",
          borderRadius: "12px",
          padding: "8px",
          margin: "12px",
        }}
      >
        <span>*EXCO Ada = keberadaan EXCO yg terverifikasi manual</span>
        <br />
        <span>
          *EXCO Lengkap = SK pengurus harian sudah terupload + minimal ada 1
          pengurus terisi
        </span>
        <br />
        <span>*Memenuhi Syarat = Adanya EXCO + memenuhi target anggota PB</span>
      </div>
      <Paper className="overview-paper-secondary">
        <Map dataKabkot={dataKabkot} />
      </Paper>
      <Gap height={20} />
      <Paper className="overview-paper-secondary">
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={3}>
            <div className="overview-paper-card">
              <p className="overview-main-value">
                {dataKabkot?.length}
                {/* <span className="overview-secondary-value">
									{' '}/{countDaerah(dataOverview?.dataOverviewKecamatan?.data?.data,verified_region)?.toLocaleString().replace(/,/g,".",)}
								</span> */}
              </p>
              <p className="overview-title-value">Jumlah Kab/Kota</p>
            </div>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <div className="overview-paper-card">
              <p className="overview-main-value">
                {filterData(dataKabkot, "0")}
                {/* <span className="overview-secondary-value">
									{' '}/{dataPengurus?.data?.total_wilayah?.pusat}
								</span> */}
              </p>
              <p className="overview-title-value">Memenuhi Syarat</p>
            </div>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <div className="overview-paper-card">
              <p className="overview-main-value">
                {filterData(dataKabkot, "1")}
                {/* <span className="overview-secondary-value">
									{' '}/{countDaerah(dataOverview?.dataOverviewProvinsi?.data?.data,verified_region)}
								</span> */}
              </p>
              <p className="overview-title-value">Kab/Kota Mempunyai EXCO</p>
            </div>
          </Grid>
          <Grid item xs={6} sm={6} md={3}>
            <div className="overview-paper-card">
              <p className="overview-main-value">
                {filterData(dataKabkot, "2")}
                {/* <span className="overview-secondary-value">
									{' '}/{countDaerah(dataOverview?.dataOverviewKabkot?.data?.data,verified_region)}
								</span> */}
              </p>
              <p className="overview-title-value">Memenuhi Target PB</p>
            </div>
          </Grid>
        </Grid>
      </Paper>
      <Gap height={20} />
      <Paper className="overview-paper-secondary">
        <div className="overview-filter">
          <span style={{ fontSize: "14px", fontWeight: "bold" }}>
            Urutkan berdasarkan
          </span>
          <select className="overview-filter-select" onChange={handleSort}>
            {optionOrderBy.map((option, index) => {
              return (
                <option value={option.id} key={index}>
                  {option.label}
                </option>
              );
            })}
          </select>
          <div className="overview-toggle">
            <div
              className={toggle === "asc" ? "active" : ""}
              onClick={() => handleSortType("asc")}
            >
              Asc
            </div>
            <div
              className={toggle === "desc" ? "active" : ""}
              onClick={() => handleSortType("desc")}
            >
              Desc
            </div>
          </div>
        </div>
        <Table dataKabkot={dataKabkot} />
      </Paper>
      <Gap height={10} />
      <div className="footer-content"></div>
    </div>
  );
};

export default DetailAnggota;
